import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=d71b0dea&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d71b0dea"]])

export default __exports__